import { appendFormDataWithObjectValues, customFetch } from 'utils/http';
import { UnexpectedError } from 'utils/errors';
import { getM8AdminURL } from 'services/production/utils/getM8URL';

type Params = {
  idPartner: number;
  blocking: boolean;
};

export const setPartnerBlocking = async (params: Params) => {
  const body = new FormData();

  appendFormDataWithObjectValues(body, params);

  const response = await customFetch(getM8AdminURL('setPartnerBlocking'), {
    method: 'PUT',
    body,
  });

  if (!response.ok) {
    throw new UnexpectedError();
  }
};
